module.exports = __webpack_public_path__ + "static/img/logo_004.eab27df2.png";